(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-team"] && !Shopify.designMode) return;
  try {
    
  window.jQuery &&
    document.querySelector(".reviews-js") &&
    $(document).ready(function () {
      $(".reviews-js").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        responsive: [
          { 
            breakpoint: 1024, 
            settings: { 
              slidesToShow: 2, 
              slidesToScroll: 1,
              arrows: true
            } 
          },
          { 
            breakpoint: 640, 
            settings: { 
              slidesToShow: 1, 
              slidesToScroll: 1,
              arrows: true
            } 
          }
        ]
      });
    });

  } catch(e) { console.error(e); }
})();
})();
